import {
  GRETA_SCROLL_BOTTOM_THRESHOLD,
  GRETA_TURN_ANCHOR_TOP_OFFSET,
} from '../../GretaAIChatMessageList.constants'

export function getGretaAIChatElementViewportTop(node, element) {
  return element.getBoundingClientRect().top - node.getBoundingClientRect().top
}

export function getGretaAIChatElementOffset(node, element) {
  return getGretaAIChatElementViewportTop(node, element) + node.scrollTop
}

// Spacer excluded so the distance is to real content, not to the spacer.
export function getGretaAIChatDistanceFromBottom(node, spacerHeight) {
  return node.scrollHeight - spacerHeight - node.scrollTop - node.clientHeight
}

export function getGretaAIChatIsPinnedToBottom(node, spacerHeight) {
  return (
    getGretaAIChatDistanceFromBottom(node, spacerHeight) <=
    GRETA_SCROLL_BOTTOM_THRESHOLD
  )
}

export function getGretaAIChatAnchorScrollTop(node, anchor) {
  return (
    node.scrollTop +
    getGretaAIChatElementViewportTop(node, anchor) -
    GRETA_TURN_ANCHOR_TOP_OFFSET
  )
}

export function getGretaAIChatBottomScrollTop(node, spacerHeight) {
  return Math.max(0, node.scrollHeight - spacerHeight - node.clientHeight)
}

// Room below the anchored turn so it can reach the top; 0 if it fills the viewport.
export function getGretaAIChatSpacerHeight({ anchor, node, spacerHeight }) {
  const contentHeight = node.scrollHeight - spacerHeight
  const turnHeight = contentHeight - getGretaAIChatElementOffset(node, anchor)

  return Math.max(
    0,
    node.clientHeight - turnHeight - GRETA_TURN_ANCHOR_TOP_OFFSET
  )
}

export function applyGretaAIChatSpacerHeight({
  anchor,
  node,
  spacer,
  spacerHeight,
}) {
  if (spacer) {
    const next = anchor
      ? getGretaAIChatSpacerHeight({ anchor, node, spacerHeight })
      : 0

    spacer.style.minHeight = `${next}px`

    return next
  }

  return spacerHeight
}
